import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#bi:bookmark-star-fill__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.999 23.25V3a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v20.25a.75.75 0 0 1-1.11.659l-7.89-4.305-7.89 4.305a.75.75 0 0 1-1.11-.659Zm9.24-17.1a.267.267 0 0 0-.48 0l-.951 1.928a.267.267 0 0 1-.201.147l-2.13.309a.267.267 0 0 0-.147.454l1.539 1.502c.063.061.091.15.076.237l-.361 2.12a.267.267 0 0 0 .387.281l1.905-1.002a.268.268 0 0 1 .247 0l1.905 1.002a.266.266 0 0 0 .386-.28l-.363-2.123a.267.267 0 0 1 .075-.237l1.542-1.501a.267.267 0 0 0-.147-.455l-2.13-.309a.267.267 0 0 1-.201-.147l-.951-1.926Z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "bi:bookmark-star-fill__a" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 0h24v24H0z" })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }